import { useTranslation } from "react-i18next";
import { Line } from "recharts";
import "../../css/Licenses/Licenses.css";
import { useEffect, useState } from "react";
import { licensesRequest } from "./Licenses_Request";

function Licenses({ theme }) {
  const { t } = useTranslation();

  const [licenses, setLicenses] = useState([]);

  useEffect(() => {
    licensesRequest(setLicenses);
  }, []); 

  return (
    <div className="mainDiv">
      <div className={`headerDiv ${theme}`}>{t("Licenses")}</div>
      <div className="contentDiv">
        <div className="licensesDiv">
          {licenses.map((item, index) => {
            return (
              <div
                key={index}
                className="licenseDiv"
                onClick={() => {
                  window.open(item.link, '_blank', "noopener,noreferrer");
                }}
              >
                <img src={item.logo}></img>
                <div>{item.name}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Licenses;
